module.exports = __webpack_public_path__ + "static/media/icon_question.c5cfc0ae.svg";